<div class="stripe-address-container">
  <div #stripeAddressElement></div>
  <div *ngIf="nameValidationError" class="name-validation-error">
    {{nameValidationError}}
  </div>
</div> 